const es = {
    'downgradeToProPlanModal.title': 'Al cambiar al Plan Pro <red>sólo podrás conservar un negocio</red>, por favor elíjelo: ', 
    'downgradeToProPlanModal.advice': 'Toma en cuenta que este cambio será efectivo de forma inmediata y se realizará el ajuste correspondiente en tu facturación.',
    'downgradeToProPlanModal.confirm': 'Confirmo y acepto que deseo cambiar a Plan Pro, además estoy consciente que esta decisión es irrevocable.',
    'downgradeToProPlanModal.buttons.downgrade': 'Cambiar a Plan Pro',
    'downgradeToProPlanModal.buttons.cancel': 'Cancelar'
}

export default es;